export default {
  conversation_dnd_message: '{name} está en modo "No molestar"',
  conversation_dnd_message_with_time:
    '{name} está en modo No molestar hasta la(s) {time, time, short}',
  conversation_dnd_message_tooltip_content: '{name} no recibirá avisos',
};
